import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulgaria = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_751)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 10.5322 23.736 9.12605 23.2536 7.82611L12 7.30434L0.746391 7.82606C0.264047 9.12605 0 10.5322 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739L12 16.6957L23.2536 16.1739C23.736 14.874 24 13.4678 24 12Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 24C17.1595 24 21.558 20.7435 23.2536 16.1739H0.746338C2.44185 20.7435 6.84037 24 11.9999 24Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.746338 7.82611H23.2536C21.558 3.2565 17.1595 0 11.9999 0C6.84037 0 2.44185 3.2565 0.746338 7.82611Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_751",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBulgaria;
